import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import MiddlewareEntities from "../../../constants/MiddlewareEntities";
import TransactionMiddlewareProxy from "./TransactionMiddlewareProxy";

export const transactionMiddleware: Middleware = (_: MiddlewareAPI) => (
  next: Dispatch
) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.TRANSACTION.FETCH_TRANSACTION_WITH_HASH:
    TransactionMiddlewareProxy.fetchTransactionWithHash(next, action);
    break;
  case ActionTypes.TRANSACTION.FETCH_TRANSACTION_WITH_SAID:
    TransactionMiddlewareProxy.fetchTransactionWithSaid(next, action);
    break;
  case `${MiddlewareEntities.TRANSACTION} ${ActionTypes.API_SUCCESS}`:
    TransactionMiddlewareProxy.transactionAPISuccess(next, action.payload);
    break;
  case `${MiddlewareEntities.TRANSACTION} ${ActionTypes.API_ERROR}`:
    TransactionMiddlewareProxy.transactionAPIError(next);
    break;
  case ActionTypes.TRANSACTION.CANCEL_TRANSACTION:
    TransactionMiddlewareProxy.cancelTransaction(next, action.payload);
    break;
  case `${MiddlewareEntities.CANCEL_TRANSACTION} ${ActionTypes.API_SUCCESS}`:
    TransactionMiddlewareProxy.cancelTransactionAPISuccess(next);
    break;
  case `${MiddlewareEntities.CANCEL_TRANSACTION} ${ActionTypes.API_ERROR}`:
    TransactionMiddlewareProxy.cancelTransactionAPIError(next);
    break;
  case ActionTypes.TRANSACTION.CANCEL_P2P_TRANSACTION:
    TransactionMiddlewareProxy.cancelPre2PostTransaction(next, action.payload);
    break;
  case `${MiddlewareEntities.CANCEL_P2P_TRANSACTION} ${ActionTypes.API_SUCCESS}`:
    TransactionMiddlewareProxy.cancelPre2PostTransactionAPISuccess(next);
    break;
  case `${MiddlewareEntities.CANCEL_P2P_TRANSACTION} ${ActionTypes.API_ERROR}`:
    TransactionMiddlewareProxy.cancelPre2PostTransactionAPIError(next);
    break;
  default:
    break;
  }
};
